/**
 * Csv Schema of BaseFretebas
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {BaseFretebas} from '@/model/resource/BaseFretebas'

/* TODO: review generated schema */
export class CsvBaseFretebasSchema extends Schema {
  readonly name = 'CsvBaseFretebas'

  readonly fieldSet: FieldSet<BaseFretebas> = {
    idFretebasPk: schema => schema.model.idFretebasPk,
    carga: schema => schema.model.carga,
    preco: schema => schema.model.preco,
    veiculos: schema => schema.model.veiculos,
    carroceria: schema => schema.model.carroceria,
    km: schema => schema.model.km,
    especie: schema => schema.model.especie,
    complemento: schema => schema.model.complemento,
    rastreamento: schema => schema.model.rastreamento,
    obs: schema => schema.model.obs,
    nextel: schema => schema.model.nextel,
    celular: schema => Helper.phone(schema.model.celular),
    fone: schema => Helper.phone(schema.model.fone),
    whatsup: schema => schema.model.whatsup,
    sac: schema => schema.model.sac,
    nome: schema => schema.model.nome,
    origem: schema => schema.model.origem,
    destino: schema => schema.model.destino,
    response: schema => schema.model.response,
  }
}
